export enum JoinType {
    MASONS_MITRE = 'MASONS_MITRE',
    FULL_MITRE = 'FULL_MITRE',
    DOG_LEG_MITRE = 'DOG_LET_MITRE',
    BUTT_JOIN = 'BUTT_JOIN',
}
